<template>
  <div class="warp">
    <div class="persona-left">
      <div class="persona-banner" @click="handleClickshowPersona"></div>
      <ul class="top-three">
        <li class="top-tow" v-for="(v, i) in topThree" :key="i">
          <div class="picture" :style="{
            'background-image': `url(${v?.avatarUrl ? v?.avatarUrl : defaultUrl})`
          }">
          </div>
          <div class="name">
            <div class="label-box">
              <div class="label-shadow">{{ v?.nickName ? v?.nickName : '暂无人选' }}</div>
              <div class="label-text">{{ v?.nickName ? v?.nickName : '暂无人选' }}</div>
            </div>
          </div>
          <div class="dedicate" :class="iconImgUrl[i].id">
            <div class="ded">
              <div class="label-box">
                <div class="label-shadow">贡献值 {{ countShow(v?.popularity) }}</div>
                <div class="label-text">贡献值 {{ countShow(v?.popularity) }}</div>
              </div>
            </div>
          </div>
          <div class="icon" :style="{
            'background-image': `url(${iconImgUrl[i].icon})`
          }">
          </div>
        </li>
      </ul>

      <!-- 4-6 -->
      <ul class="bottom-three">
        <li class="three-item" v-for="(item, k) in fourToSix" :key="k">
          <div class="title1">
            <div class="label-box">
              <div class="label-shadow">{{ k + 4 }}</div>
              <div class="label-text">{{ k + 4 }}</div>
            </div>
          </div>
          <div class="user">
            <div class="avatar" :style="{
              'background-image': `url(${item?.avatarUrl ? item?.avatarUrl : defaultUrl})`
            }">
            </div>
            <div class="name">{{ item?.nickName || '-' }}</div>
          </div>
          <div class="hot">
            贡献值 {{ countShow(item?.popularity) }}
          </div>
        </li>
      </ul>
    </div>
    <div class="persona-right">
      <div class="fan-center">
        <div class="title-box">
          <div class="item title1">
            <div class="bg"></div>
            <div class="label-box">
              <span class="label-shadow">排名</span>
              <span class="label-text">排名</span>
            </div>
          </div>
          <div class="item title2">
            <div class="inner">
              <div class="bg"></div>
              <div class="label-box">
                <span class="label-shadow">粉丝昵称</span>
                <span class="label-text">粉丝昵称</span>
              </div>
            </div>
          </div>
          <div class="item title3">
            <div class="bg"></div>
            <div class="label-box">
              <span class="label-shadow">贡献值</span>
              <span class="label-text">贡献值</span>
            </div>
          </div>
        </div>
        <div class="fan-box">
          <div class="fan-center-warp" v-if="sevenAndBeyond && sevenAndBeyond.length > 0">
            <div class="list-items" v-for="(item, index) in sevenAndBeyond" :key="index">
              <div class="first">
                <div class="label-box">
                  <span class="label-shadow">{{ index + 7 }}</span>
                  <span class="label-text">{{ index + 7 }}</span>
                </div>
              </div>
              <div class="nanu">
                <div class="avatar" :style="{ 'background-image': `url(${item?.avatarUrl || defaultUrl})` }"></div>
                <div class="name">
                  {{ item.nickName || '-' }}
                </div>
              </div>

              <div class="hot">
                {{ countShow(item?.popularity) }}
              </div>
            </div>
            <div class="placeholder"></div>
          </div>
        </div>
      </div>
      <userTeamRankings :userInfo="personaList?.personal" :useImgUrl="personaList?.personal.avatarUrl" />
    </div>

  </div>
</template>

<script>
import userTeamRankings from '@/views/ranking/userTeamRankings'

export default {
  components: {
    userTeamRankings
  },
  inject: ['handleCkickshowPop'],
  props: {
    personaList: Object,
    countShow: Function
  },
  data() {
    return {
      defaultUrl: 'https://website.xdcdn.net/form/match/avatar2024/Portrait1.png',
      iconImgUrl: [
        {
          icon: "https://website.xdcdn.net/poster/355916/sausage-match/FHkDBo3P.png",
          id: 'rank-2'
        },
        {
          icon: "https://website.xdcdn.net/poster/355916/sausage-match/FHkDBYl0.png",
          id: 'rank-1'
        },
        {
          icon: "https://website.xdcdn.net/poster/355916/sausage-match/FHkDBgnP.png",
          id: 'rank-3'
        }
      ],
      numberImg: [
        "https://website.xdcdn.net/poster/355916/sausage-match/FHlAu1YQ.png",
        "https://website.xdcdn.net/poster/355916/sausage-match/FHlAuzm0.png",
        "https://website.xdcdn.net/poster/355916/sausage-match/FHlAu7l8.png"
      ],
    }
  },
  computed: {
    // 筛选第 1-3 名的数据

    topThree() {
      let topItems = this.personaList.totalList.filter((item, index) => index >= 0 && index <= 2);
      // console.log('topItems',topItems)
      // 如果只有一个元素，返回 "0, 1, 0" 的排列方式

      if (topItems.length == 0) {
        return [null, null, null];
      } else if (topItems.length == 1) {
        return [null, topItems[0], null];
      } else if (topItems.length == 2) {
        return [topItems[1], topItems[0], null];
      } else {
        return [topItems[1], topItems[0], topItems[2]];
      }
    },
    // 筛选第 4-6 名的数据
    fourToSix() {
      let center = this.personaList.totalList.filter((item, index) => index >= 3 && index <= 5);

      let result = [null, null, null];
      // 将 `center` 的内容填充到 `result` 中
      center.forEach((item, index) => {
        result[index] = item;
      });
      return result;
    },
    // 筛选第 7 名及之后的数据
    sevenAndBeyond() {
      return this.personaList.totalList?.filter((item, index) => index >= 6);
    }
  },
  methods: {
    handleClickshowPersona() {
      this.handleCkickshowPop()
    }
  },
}

</script>

<style lang="scss" scoped>
@import '~@/assets/scss/ranking/personal';
</style>